"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearDeleteAssetError = clearDeleteAssetError;
exports.createAssetSuccess = createAssetSuccess;
exports.deleteAsset = deleteAsset;
exports.deleteAssetDetail = deleteAssetDetail;
exports.deleteAssetSuccess = deleteAssetSuccess;
exports.deleteIcon = void 0;
exports.deleteIconRoot = deleteIconRoot;
exports.deprecateAsset = void 0;
exports.fetchAssetFailure = fetchAssetFailure;
exports.fetchAssetRequest = fetchAssetRequest;
exports.fetchAssetSuccess = fetchAssetSuccess;
exports.getAsset = getAsset;
exports.getVersionsDependents = exports.getVersionsDependencies = exports.getVersionGroups = exports.getMinorVersions = exports.getLifecycleStateActions = void 0;
exports.goToCreatedAssetDetail = goToCreatedAssetDetail;
exports.removeAssetCategory = removeAssetCategory;
exports.revertDeprecateAsset = exports.resetVersionsDependents = exports.resetVersionsDependencies = void 0;
exports.updateAssetCategory = updateAssetCategory;
exports.updateAssetMetadata = void 0;
exports.updateCategoriesFailure = updateCategoriesFailure;
exports.updateCategoriesRequest = updateCategoriesRequest;
exports.updateCategoriesSuccess = updateCategoriesSuccess;
exports.updateIcon = exports.updateDescription = exports.updateContactName = exports.updateContactEmail = void 0;
exports.updateIconRoot = updateIconRoot;
exports.updateName = exports.updateMinorVersions = exports.updateLabels = void 0;
exports.updateRating = updateRating;
exports.updateVisibility = exports.updateStatus = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _exchangeApiClient = require("@mulesoft/exchange-api-client");
var _actionify = _interopRequireDefault(require("../../utils/actionify"));
var _analytics = require("../../utils/analytics");
var arraysUtils = _interopRequireWildcard(require("../../utils/arrays"));
var imagesUtils = _interopRequireWildcard(require("../../utils/images"));
var sessionSelectors = _interopRequireWildcard(require("../session/selectors"));
var portalsActions = _interopRequireWildcard(require("../portals/actions"));
var actions = _interopRequireWildcard(require("./actionTypes"));
var events = _interopRequireWildcard(require("./events"));
var assetsSelectors = _interopRequireWildcard(require("./selectors"));
var _assets = require("../../utils/assets");
var _utils = require("./utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t4 in e) "default" !== _t4 && {}.hasOwnProperty.call(e, _t4) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t4)) && (i.get || i.set) ? o(f, _t4, i) : f[_t4] = e[_t4]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function clearDeleteAssetError() {
  return {
    type: actions.CLEAR_DELETE_ASSET_ERROR
  };
}
function updateRating(_ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId,
    version = _ref.version,
    rating = _ref.rating,
    numberOfRates = _ref.numberOfRates;
  return {
    type: actions.UPDATE_RATING,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version,
      rating: rating,
      numberOfRates: numberOfRates
    }
  };
}

/** Updates asset labels */
var updateLabels = exports.updateLabels = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return service.updateLabels;
}, actions.UPDATE_LABELS, {
  successProps: function successProps(params) {
    return (0, _analytics.clientTrackPayload)({
      eventSchema: events.TAGS_UPDATED,
      properties: {
        groupId: params.groupId,
        assetId: params.assetId,
        version: params.version
      }
    });
  }
});
function getNewCategories(_ref2) {
  var categories = _ref2.categories,
    category = _ref2.category;
  var oldCategoryIndex = categories.findIndex(function (cat) {
    return cat.key === category.key;
  });
  if (oldCategoryIndex !== -1) {
    // Update of an existing category
    return arraysUtils.replaceInArray(categories, category, {
      index: oldCategoryIndex
    });
  }
  return [].concat((0, _toConsumableArray2.default)(categories), [category]);
}
function updateCategoriesRequest(_ref3) {
  var groupId = _ref3.groupId,
    assetId = _ref3.assetId,
    version = _ref3.version,
    categories = _ref3.categories;
  return {
    type: actions.UPDATE_ASSET_CATEGORIES.REQUEST,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version,
      categories: categories
    }
  };
}
function updateCategoriesFailure(_ref4) {
  var groupId = _ref4.groupId,
    assetId = _ref4.assetId,
    version = _ref4.version,
    categories = _ref4.categories;
  return {
    type: actions.UPDATE_ASSET_CATEGORIES.FAILURE,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version,
      categories: categories
    }
  };
}
function updateCategoriesSuccess(asset) {
  return _objectSpread({
    type: actions.UPDATE_ASSET_CATEGORIES.SUCCESS
  }, (0, _analytics.clientTrackPayload)({
    eventSchema: events.CATEGORIES_UPDATED,
    properties: events.assetProperties(asset)
  }));
}

/** Updates asset categories */
function updateAssetCategory(_ref5) {
  var groupId = _ref5.groupId,
    assetId = _ref5.assetId,
    version = _ref5.version,
    categories = _ref5.categories,
    category = _ref5.category;
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState, _ref6) {
      var config, state, currentAsset, context, oldCategories, newCategories, categoryService, _t;
      return _regenerator.default.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            config = _ref6.config;
            state = getState();
            currentAsset = assetsSelectors.asset(state, {
              groupId: groupId,
              assetId: assetId,
              version: version
            });
            context = sessionSelectors.context(state);
            oldCategories = (0, _toConsumableArray2.default)(categories);
            newCategories = getNewCategories({
              categories: categories,
              category: category
            });
            categoryService = new _exchangeApiClient.CategoryService(config);
            dispatch(updateCategoriesRequest({
              groupId: groupId,
              assetId: assetId,
              version: version,
              categories: newCategories
            }));
            _context.prev = 1;
            _context.next = 2;
            return categoryService.updateAssetCategory({
              groupId: groupId,
              assetId: assetId,
              version: version,
              category: category,
              context: context
            });
          case 2:
            dispatch(updateCategoriesSuccess(currentAsset));
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            dispatch(updateCategoriesFailure({
              groupId: groupId,
              assetId: assetId,
              version: version,
              categories: oldCategories
            }));
            throw _t;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref7.apply(this, arguments);
    };
  }();
}

/** Removes a category from the asset */
function removeAssetCategory(_ref8) {
  var groupId = _ref8.groupId,
    assetId = _ref8.assetId,
    version = _ref8.version,
    categories = _ref8.categories,
    category = _ref8.category;
  return /*#__PURE__*/function () {
    var _ref0 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch, getState, _ref9) {
      var config, state, currentAsset, context, oldCategories, newCategories, categoryService, _t2;
      return _regenerator.default.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            config = _ref9.config;
            state = getState();
            currentAsset = assetsSelectors.asset(state, {
              groupId: groupId,
              assetId: assetId,
              version: version
            });
            context = sessionSelectors.context(state);
            oldCategories = (0, _toConsumableArray2.default)(categories);
            newCategories = categories.filter(function (cat) {
              return !(cat.key === category.key);
            });
            categoryService = new _exchangeApiClient.CategoryService(config);
            dispatch(updateCategoriesRequest({
              groupId: groupId,
              assetId: assetId,
              version: version,
              categories: newCategories
            }));
            _context2.prev = 1;
            _context2.next = 2;
            return categoryService.removeAssetCategory({
              groupId: groupId,
              assetId: assetId,
              version: version,
              category: category,
              context: context
            });
          case 2:
            dispatch(updateCategoriesSuccess(currentAsset));
            _context2.next = 4;
            break;
          case 3:
            _context2.prev = 3;
            _t2 = _context2["catch"](1);
            dispatch(updateCategoriesFailure({
              groupId: groupId,
              assetId: assetId,
              version: version,
              categories: oldCategories
            }));
            throw _t2;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function (_x4, _x5, _x6) {
      return _ref0.apply(this, arguments);
    };
  }();
}

/** Marks an asset as "deprecated" */
var deprecateAsset = exports.deprecateAsset = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(_ref1) {
      var context, groupId, assetId, minorVersion, version;
      return _regenerator.default.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            context = _ref1.context, groupId = _ref1.groupId, assetId = _ref1.assetId, minorVersion = _ref1.minorVersion, version = _ref1.version;
            if (!minorVersion) {
              _context3.next = 2;
              break;
            }
            _context3.next = 1;
            return service.updateStatus({
              context: context,
              groupId: groupId,
              assetId: assetId,
              minorVersion: minorVersion,
              status: 'deprecated'
            });
          case 1:
            return _context3.abrupt("return");
          case 2:
            _context3.next = 3;
            return service.updateStatus({
              context: context,
              groupId: groupId,
              assetId: assetId,
              version: version,
              status: 'deprecated'
            });
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x7) {
      return _ref10.apply(this, arguments);
    };
  }();
}, actions.DEPRECATE_ASSET);

/** Removes "deprecation" status from an asset */
var revertDeprecateAsset = exports.revertDeprecateAsset = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(_ref11) {
      var context, groupId, assetId, minorVersion, version;
      return _regenerator.default.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            context = _ref11.context, groupId = _ref11.groupId, assetId = _ref11.assetId, minorVersion = _ref11.minorVersion, version = _ref11.version;
            if (!minorVersion) {
              _context4.next = 2;
              break;
            }
            _context4.next = 1;
            return service.updateStatus({
              context: context,
              groupId: groupId,
              assetId: assetId,
              minorVersion: minorVersion,
              status: 'published'
            });
          case 1:
            return _context4.abrupt("return");
          case 2:
            _context4.next = 3;
            return service.updateStatus({
              context: context,
              groupId: groupId,
              assetId: assetId,
              version: version,
              status: 'published'
            });
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x8) {
      return _ref12.apply(this, arguments);
    };
  }();
}, actions.REVERT_DEPRECATE_ASSET);
function getNextAsset(_ref13, pushFn, getPath) {
  var groupId = _ref13.groupId,
    assetId = _ref13.assetId,
    type = _ref13.type,
    minorVersion = _ref13.minorVersion;
  return function (dispatch, getState) {
    var state = getState();
    var currentMinorVersions = assetsSelectors.assetMinorVersions(state, {
      groupId: groupId,
      assetId: assetId
    });
    if (!currentMinorVersions.length) {
      return pushFn(getPath('home'));
    }
    var currentMinorVersion = currentMinorVersions.find(function (cmv) {
      return cmv.minorVersion === minorVersion;
    });
    var pageParams = {
      groupId: groupId,
      assetId: assetId,
      type: type,
      minorVersion: currentMinorVersion ? minorVersion : currentMinorVersions[0].minorVersion
    };
    return pushFn(getPath('page', pageParams));
  };
}
function deleteAssetRequest() {
  return {
    type: actions.DELETE_ASSET.REQUEST
  };
}
function deleteAssetSuccess(params) {
  return {
    type: actions.DELETE_ASSET.SUCCESS,
    asset: {
      groupId: params.groupId,
      assetId: params.assetId,
      version: params.version,
      minorVersion: params.minorVersion
    }
  };
}
function deleteAssetFailure() {
  return {
    type: actions.DELETE_ASSET.FAILURE
  };
}
function deleteAssetConflictDueToDependents(_ref14) {
  var groupId = _ref14.groupId,
    assetId = _ref14.assetId,
    version = _ref14.version,
    dependents = _ref14.dependents;
  return {
    type: actions.DELETE_ASSET_CONFLICT_DUE_TO_DEPENDENTS,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version,
      dependents: dependents
    }
  };
}

/** Deletes an asset version */
function deleteAsset(_ref15) {
  var groupId = _ref15.groupId,
    assetId = _ref15.assetId,
    minorVersion = _ref15.minorVersion,
    version = _ref15.version,
    _ref15$isCurrent = _ref15.isCurrent,
    isCurrent = _ref15$isCurrent === void 0 ? true : _ref15$isCurrent,
    pushFn = _ref15.pushFn,
    getPath = _ref15.getPath,
    closeModal = _ref15.closeModal,
    deleteType = _ref15.deleteType;
  return /*#__PURE__*/function () {
    var _ref17 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch, getState, _ref16) {
      var config, state, context, deletedVersion, assetService, _t3;
      return _regenerator.default.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            config = _ref16.config;
            state = getState();
            context = sessionSelectors.context(state);
            deletedVersion = assetsSelectors.asset(state, {
              groupId: groupId,
              assetId: assetId,
              version: version
            });
            assetService = new _exchangeApiClient.AssetService(config);
            dispatch(deleteAssetRequest());
            _context5.prev = 1;
            _context5.next = 2;
            return assetService.remove({
              groupId: groupId,
              assetId: assetId,
              version: version,
              context: context,
              createdAt: deletedVersion.createdAt,
              deleteType: deleteType
            });
          case 2:
            if (deletedVersion.versions && deletedVersion.versions.length === 1) {
              dispatch(deleteAssetSuccess({
                groupId: groupId,
                assetId: assetId,
                version: version,
                minorVersion: minorVersion
              }));
            } else {
              dispatch(deleteAssetSuccess({
                groupId: groupId,
                assetId: assetId,
                version: version
              }));
            }
            closeModal({
              versionDeleted: true,
              groupId: groupId,
              assetId: assetId,
              version: version
            });
            if (isCurrent) {
              dispatch(getNextAsset(deletedVersion, pushFn, getPath));
            }
            _context5.next = 5;
            break;
          case 3:
            _context5.prev = 3;
            _t3 = _context5["catch"](1);
            dispatch(deleteAssetFailure());
            if (!(_t3.status === 409 && _t3.details && _t3.details.dependents)) {
              _context5.next = 4;
              break;
            }
            dispatch(deleteAssetConflictDueToDependents({
              groupId: groupId,
              assetId: assetId,
              version: version,
              dependents: _t3.details.dependents
            }));
            return _context5.abrupt("return", false);
          case 4:
            closeModal();
            throw _t3;
          case 5:
            return _context5.abrupt("return", true);
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x9, _x0, _x1) {
      return _ref17.apply(this, arguments);
    };
  }();
}
function deleteAssetDetail(_ref18) {
  var groupId = _ref18.groupId,
    assetId = _ref18.assetId,
    version = _ref18.version;
  return {
    type: actions.DELETE_ASSET_DETAIL,
    asset: {
      groupId: groupId,
      assetId: assetId,
      version: version
    }
  };
}
function createAssetSuccess(asset) {
  return _objectSpread({
    type: actions.CREATE_ASSET.SUCCESS,
    asset: asset
  }, (0, _analytics.clientTrackPayload)({
    eventSchema: events.ASSET_CREATED,
    properties: events.assetProperties(asset)
  }));
}
function goToCreatedAssetDetail(_ref19) {
  var groupId = _ref19.groupId,
    assetId = _ref19.assetId,
    version = _ref19.version,
    getPath = _ref19.getPath,
    pushFn = _ref19.pushFn;
  return /*#__PURE__*/function () {
    var _ref21 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch, getState, _ref20) {
      var config, state, context, minorVersion, assetService, newAsset;
      return _regenerator.default.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            config = _ref20.config;
            state = getState();
            context = sessionSelectors.context(state);
            minorVersion = (0, _assets.getMinorVersion)(version);
            assetService = new _exchangeApiClient.AssetService(config);
            _context6.next = 1;
            return assetService.get({
              context: context,
              groupId: groupId,
              assetId: assetId,
              version: version,
              status: ['development', 'published', 'deprecated'],
              minorVersion: minorVersion
            });
          case 1:
            newAsset = _context6.sent;
            dispatch(createAssetSuccess(newAsset));
            pushFn(getPath('page', newAsset));
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x10, _x11, _x12) {
      return _ref21.apply(this, arguments);
    };
  }();
}
function fetchAssetRequest(identifier, assetPromise) {
  return _objectSpread({
    type: actions.FETCH_ASSET.REQUEST,
    assetPromise: assetPromise
  }, identifier);
}
function fetchAssetSuccess(asset, identifier) {
  return _objectSpread({
    type: actions.FETCH_ASSET.SUCCESS,
    asset: asset
  }, identifier);
}
function fetchAssetFailure(identifier) {
  return _objectSpread({
    type: actions.FETCH_ASSET.FAILURE
  }, identifier);
}
var selectExistingAssetPromise = function selectExistingAssetPromise(state, identifier) {
  return state.assets.detail.promises[(0, _utils.getIdentifierPath)(identifier)];
};

/** Gets an asset and set it into the state */
function getAsset(_ref22) {
  var domain = _ref22.domain,
    groupId = _ref22.groupId,
    assetId = _ref22.assetId,
    version = _ref22.version,
    minorVersion = _ref22.minorVersion,
    status = _ref22.status,
    _ref22$showLoading = _ref22.showLoading,
    showLoading = _ref22$showLoading === void 0 ? true : _ref22$showLoading;
  return function (dispatch, getState, _ref23) {
    var config = _ref23.config;
    var state = getState();
    var identifier = {
      domain: domain,
      groupId: groupId,
      assetId: assetId,
      version: version,
      minorVersion: minorVersion,
      status: status
    };
    var currentAsset = assetsSelectors.asset(state, identifier);
    var assetLoadingFn = function assetLoadingFn($value) {
      if ($value) {
        return dispatch(portalsActions.assetLoading());
      }
      return dispatch(portalsActions.assetLoaded());
    };
    var loadingFn = showLoading ? assetLoadingFn : function () {};
    if (currentAsset && currentAsset.isCompleted && !currentAsset.isMinorVersionTransition) {
      // reuses current asset if matches with props
      return Promise.resolve(currentAsset);
    }
    var existingPromise = selectExistingAssetPromise(state, identifier);
    if (existingPromise) {
      return existingPromise;
    }
    var context = sessionSelectors.context(state);
    var isLCSEnabled = sessionSelectors.isLCSEnabled(state);
    var validStatuses = sessionSelectors.validAssetStatuses(state);
    var statuses = arraysUtils.convertToArray(status);
    var statusesForQuery;
    if (!isLCSEnabled || statuses.length === 0) {
      statusesForQuery = validStatuses;
    } else {
      statusesForQuery = statuses;
    }
    loadingFn(true);
    var assetService = new _exchangeApiClient.AssetService(config);
    var assetPromise = assetService.get({
      domain: domain,
      groupId: groupId,
      assetId: assetId,
      version: version,
      status: statusesForQuery,
      strict: !isLCSEnabled,
      minorVersion: minorVersion,
      context: context
    });
    dispatch(fetchAssetRequest(identifier, assetPromise));
    return assetPromise.then(function (asset) {
      dispatch(fetchAssetSuccess(asset, identifier));
      loadingFn(false);
      return asset;
    }).catch(function (error) {
      dispatch(fetchAssetFailure(identifier));
      if (error.status === 403) {
        // eslint-disable-next-line no-param-reassign
        error.description = 'You don’t have permissions to view this package. Please contact your administrator.';
      }
      throw error;
    });
  };
}

/** Updates the metadata of an asset */
var updateAssetMetadata = exports.updateAssetMetadata = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return function (_ref24) {
    var context = _ref24.context,
      asset = _ref24.asset,
      metadata = _ref24.metadata;
    return service.updateMetadata({
      context: context,
      groupId: asset.groupId,
      assetId: asset.assetId,
      metadata: metadata
    });
  };
}, actions.UPDATE_METADATA, {
  successProps: function successProps(params) {
    return (0, _analytics.clientTrackPayload)({
      eventSchema: events.ASSET_METADATA_EDITED,
      properties: _objectSpread(_objectSpread({}, events.assetProperties(params.asset)), params.metadata)
    });
  }
});

/** Updates the name of an asset */
var updateName = exports.updateName = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return function (_ref25) {
    var context = _ref25.context,
      asset = _ref25.asset,
      name = _ref25.name;
    return service.updateMetadata({
      context: context,
      groupId: asset.groupId,
      assetId: asset.assetId,
      metadata: {
        name: name
      }
    });
  };
}, actions.UPDATE_NAME, {
  successProps: function successProps(params) {
    return (0, _analytics.clientTrackPayload)({
      eventSchema: events.ASSET_NAME_EDITED,
      properties: _objectSpread(_objectSpread({}, events.assetProperties(params.asset)), {}, {
        name: params.name
      })
    });
  }
});

/** Updates the name of an asset */
var updateContactName = exports.updateContactName = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return function (_ref26) {
    var context = _ref26.context,
      asset = _ref26.asset,
      contactName = _ref26.contactName;
    return service.updateMetadata({
      context: context,
      groupId: asset.groupId,
      assetId: asset.assetId,
      metadata: {
        contactName: contactName
      }
    });
  };
}, actions.UPDATE_CONTACT_NAME, {
  successProps: function successProps(params) {
    return (0, _analytics.clientTrackPayload)({
      eventSchema: events.ASSET_CONTACT_NAME_EDITED,
      properties: _objectSpread(_objectSpread({}, events.assetProperties(params.asset)), {}, {
        contactName: params.contactName
      })
    });
  }
});

/** Updates the name of an asset */
var updateContactEmail = exports.updateContactEmail = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return function (_ref27) {
    var context = _ref27.context,
      asset = _ref27.asset,
      contactEmail = _ref27.contactEmail;
    return service.updateMetadata({
      context: context,
      groupId: asset.groupId,
      assetId: asset.assetId,
      metadata: {
        contactEmail: contactEmail
      }
    });
  };
}, actions.UPDATE_CONTACT_EMAIL, {
  successProps: function successProps(params) {
    return (0, _analytics.clientTrackPayload)({
      eventSchema: events.ASSET_CONTACT_EMAIL_EDITED,
      properties: _objectSpread(_objectSpread({}, events.assetProperties(params.asset)), {}, {
        contactEmail: params.contactEmail
      })
    });
  }
});

/** Updates the icon of an asset */
var updateIcon = exports.updateIcon = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return /*#__PURE__*/function () {
    var _ref29 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee7(_ref28) {
      var context, asset, icon, processedIcon;
      return _regenerator.default.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            context = _ref28.context, asset = _ref28.asset, icon = _ref28.icon;
            processedIcon = icon;
            if (!(icon.type !== 'image/svg+xml')) {
              _context7.next = 2;
              break;
            }
            _context7.next = 1;
            return imagesUtils.getResizedImage(icon);
          case 1:
            processedIcon = _context7.sent;
          case 2:
            return _context7.abrupt("return", service.updateIcon({
              context: context,
              groupId: asset.groupId,
              assetId: asset.assetId,
              iconFile: processedIcon
            }));
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x13) {
      return _ref29.apply(this, arguments);
    };
  }();
}, actions.UPDATE_ICON, {
  successProps: function successProps(params) {
    return (0, _analytics.clientTrackPayload)({
      eventSchema: events.ASSET_ICON_EDITED,
      properties: events.assetProperties(params.asset)
    });
  }
});

/** Deletes the icon of an asset */
var deleteIcon = exports.deleteIcon = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return function (_ref30) {
    var context = _ref30.context,
      asset = _ref30.asset;
    return service.deleteIcon({
      context: context,
      groupId: asset.groupId,
      assetId: asset.assetId
    });
  };
}, actions.DELETE_ICON, {
  successProps: function successProps(params) {
    return (0, _analytics.clientTrackPayload)({
      eventSchema: events.ASSET_ICON_DELETED,
      properties: events.assetProperties(params.asset)
    });
  }
});

/* Updates the icon of an asset in the root store */
function updateIconRoot(_ref31, externalLink) {
  var groupId = _ref31.groupId,
    assetId = _ref31.assetId;
  return {
    type: actions.UPDATE_ICON_ROOT,
    params: {
      asset: {
        groupId: groupId,
        assetId: assetId
      },
      icon: {
        externalLink: externalLink
      }
    }
  };
}

/* Deletes the icon of an asset in the root store */
function deleteIconRoot(_ref32) {
  var groupId = _ref32.groupId,
    assetId = _ref32.assetId;
  return {
    type: actions.DELETE_ICON_ROOT,
    params: {
      asset: {
        groupId: groupId,
        assetId: assetId
      }
    }
  };
}
/** Updates the description of an asset */
var updateDescription = exports.updateDescription = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return function (_ref33) {
    var context = _ref33.context,
      asset = _ref33.asset,
      description = _ref33.description;
    return service.updateMetadata({
      context: context,
      groupId: asset.groupId,
      assetId: asset.assetId,
      metadata: {
        description: description
      }
    });
  };
}, actions.UPDATE_DESCRIPTION, {
  successProps: function successProps(params) {
    return (0, _analytics.clientTrackPayload)({
      eventSchema: events.ASSET_DESCRIPTION_EDITED,
      properties: events.assetProperties(params.asset)
    });
  }
});

/** Updates the status of an asset */
var updateStatus = exports.updateStatus = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return function (_ref34) {
    var context = _ref34.context,
      asset = _ref34.asset,
      status = _ref34.status;
    return service.updateStatus({
      context: context,
      groupId: asset.groupId,
      assetId: asset.assetId,
      version: asset.version,
      status: status
    });
  };
}, actions.UPDATE_STATUS, {
  successProps: function successProps(params) {
    return (0, _analytics.clientTrackPayload)({
      eventSchema: events.ASSET_STATUS_EDITED,
      properties: _objectSpread(_objectSpread({}, events.assetProperties(params.asset)), {}, {
        status: params.status
      })
    });
  }
});

/** Gets the dependencies for all versions of an asset */
var getVersionsDependencies = exports.getVersionsDependencies = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return service.getVersionsDependencies;
}, actions.GET_VERSIONS_DEPENDENCIES);
var resetVersionsDependencies = exports.resetVersionsDependencies = function resetVersionsDependencies(_ref35) {
  var groupId = _ref35.groupId,
    assetId = _ref35.assetId;
  return {
    type: actions.RESET_VERSIONS_DEPENDENCIES,
    groupId: groupId,
    assetId: assetId
  };
};

/** Gets the dependents for an asset */
var getVersionsDependents = exports.getVersionsDependents = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return service.getVersionsDependents;
}, actions.GET_VERSIONS_DEPENDENTS, {
  once: true,
  requestCompare: function requestCompare(params, oldParams) {
    return params.groupId === oldParams.groupId && params.assetId === oldParams.assetId;
  }
});
var resetVersionsDependents = exports.resetVersionsDependents = function resetVersionsDependents(_ref36) {
  var groupId = _ref36.groupId,
    assetId = _ref36.assetId;
  return {
    type: actions.RESET_VERSIONS_DEPENDENTS,
    groupId: groupId,
    assetId: assetId
  };
};

/** Gets the version groups for an asset */
var getVersionGroups = exports.getVersionGroups = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return service.getVersionGroups;
}, actions.GET_VERSION_GROUPS, {
  once: true,
  requestCompare: function requestCompare(params, oldParams) {
    return params.groupId === oldParams.groupId && params.assetId === oldParams.assetId;
  }
});

/** Gets the minor versions for an asset */
var getMinorVersions = exports.getMinorVersions = function getMinorVersions(_ref37) {
  var groupId = _ref37.groupId,
    assetId = _ref37.assetId,
    domain = _ref37.domain;
  return function (dispatch, getState) {
    var state = getState();
    var status = sessionSelectors.validAssetStatuses(state);
    var minorVerionsFn = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
      return service.getMinorVersions;
    }, actions.GET_MINOR_VERSIONS, {
      once: true,
      requestCompare: function requestCompare(params, oldParams) {
        return params.groupId === oldParams.groupId && params.assetId === oldParams.assetId;
      }
    });
    return dispatch(minorVerionsFn({
      groupId: groupId,
      assetId: assetId,
      domain: domain,
      status: status
    }));
  };
};

/** Updates the visibility on the public portal for an asset */
var updateVisibility = exports.updateVisibility = (0, _actionify.default)(_exchangeApiClient.PortalService, function (service) {
  return service.updateVisibility;
}, actions.UPDATE_VISIBILITY);

/** Gets the lifecycle state actions for an asset */
var getLifecycleStateActions = exports.getLifecycleStateActions = (0, _actionify.default)(_exchangeApiClient.AssetService, function (service) {
  return service.getLifeCycleStatesActions;
}, actions.GET_LIFECYCLE_STATES_ACTIONS, {
  requestCompare: function requestCompare(params, oldParams) {
    return params.groupId === oldParams.groupId && params.assetId === oldParams.assetId && params.version === oldParams.version;
  }
});
var updateMinorVersions = exports.updateMinorVersions = function updateMinorVersions(_ref38) {
  var asset = _ref38.asset;
  return function (dispatch, getState) {
    var state = getState();
    var assets = assetsSelectors.assetVersions(state, asset);
    dispatch({
      type: actions.UPDATE_MINOR_VERSIONS,
      params: {
        asset: asset,
        assets: assets
      }
    });
  };
};
//# sourceMappingURL=actions.js.map